import { AngularFirestore } from 'angularfire2/firestore';
import { DataModel, IDataModel } from './data.model'


export interface IChatPersons{
    owner?:string,
    name?:string,
    sigla?:string,
    readOnly?:number,
}

export interface IChatMessages {
    owner:string,
    type: string,
    title?:string,
    refer?: number,
    timestamp?: Date,
    content: string,
    from?: string,
    to?: string,
    read:boolean,
    link? :  { tipo: string, nome: string, id:string}
  }
  
export class ChatMessages extends DataModel<IChatMessages>  {
    constructor(private db: AngularFirestore) {
        super(db,'chatMessages');

    }

    enviarPara(tipo,refer,titulo,emailDe,emailPara,mensagem, link?){
       let obj : IChatMessages= 
         {owner : '',title:titulo,from:emailDe,to:emailPara,
         type:tipo,content:mensagem,read:false,timestamp:new Date(),refer:Number(refer) || 0
         
        }
        if (link)
          obj.link = link;
       this.add(obj);
    }

}

export class ChatPersons extends DataModel<IChatPersons>
{
    constructor(private db: AngularFirestore) {
        super(db,'chatPersons');
    }

}